import {
  Button,
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  InputLabel,
  NativeSelect,
  Tooltip,
} from '@mui/material';

import { ChangeEvent, useMemo, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { AppealPropsI } from '../../interfaces/appealsAPI';
import { OperatorsListI, OperatorsSubListI } from '../../interfaces/filters';
import './SingleAppeal.scss';
import cn from 'classnames';
import { sendEmail } from '../../utils/sendEmail';
import { useAppSelector } from '../../hooks/hooks';


const SingleAppeal = (props: AppealPropsI) => {     // структура (строка) каждого обращения. Берет данные из родителя RequestsFromApp.tsx
  const {
    fio,
    login,
    date_question,
    date_response,
    date_final_ask,
    ques_name,
    question,
    email,
    phone,
    listUsers,
    listSubUsers,
    handleOpen,
    id,
    response,
    draft,
    priority,
    operator_id,
    operator_sub_id,
    date_destination,
    phone_status,
    question_status,
    userRole,
    sender_name,
    files,
    changeOperator,
    changePriority,
    changeStatus,
    changePhoneResponse,
    countingPassedDays,
    address,
    handleOpenModalSend,
    DUBLICATE_STATUS,
    ANSWER_STATUS,
    isChecked,
    onCheckBoxChange,
    appealHistory,
  } = props;

 
  const [expand, setExpand] = useState(true);
  const remainingDays = countingPassedDays(date_question);

  const summaryContent = expand
    ? `${question.length > 70 ? question.substring(0, 70) + '...' : question}`
    : null;

  const handleOpenProps = {          // данные модального окна (что передается в модальное окно)
    appealId: id,
    appealDate: date_question,
    dateResponse: date_response,
    appealResponseText: response,
    appealDraftText: draft,
    appealFio: fio,
    appealLogin: login,
    appealEmail: email,
    appealPhone: phone,
    appealAddress: address,
    appealQestion: question,
    appealHistory: appealHistory,
    appealFiles: files,
    appealQuestionStatus: question_status,
  };

  //styles appeals color
  const appealColor = cn(       
    { reminderColor__yellow: remainingDays >= 26 && remainingDays <= 30 && question_status !== '4' && question_status !== '5'},     // подсвечивать желтым за 5 дней до истечения срока
    { reminderColor__red: remainingDays > 30 && question_status !== '4' && question_status !== '5' },                               // истек срок
    { priorityColor__green: priority === '2' && question_status !== '4' },                                                          // приоритет "Высокий" 
    { priorityColor__yellow: priority === '3' && question_status !== '4' },                                                         // приоритет "Средний" 
    { doubleColor__purple: DUBLICATE_STATUS === '1' && question_status !== '4' },                                                   // подсвечивать дубли
    { reminderColor__red: remainingDays > 60 && question_status === '5' },                                                          // истек срок ПРОДЛЕННЫХ обращений
    { reminderColor__yellow: remainingDays >= 56 && remainingDays <= 60 && question_status === '5' },                               // подсвечивать желтым за 5 дней до истечения срока ПРОДЛЕННЫХ обращений
    { newMessage__svg: ANSWER_STATUS === '1' },                                                                                     // новое сообщение от абонента
  );

  const appealClosed = cn({ closed: question_status === '4' });

  const answeredByPhone = (e: ChangeEvent<HTMLInputElement>) => {
    changePhoneResponse({ id, phone_status: e.target.checked ? '2' : '1' });
  };

  const renderOperators = (operators: Array<OperatorsListI> = []) => {                    // отрисовывается список операторов
    return operators.map(({ ID, USER_LOGIN, LAST_NAME }) => {
      return (
        <option key={ID} value={ID}>
          {LAST_NAME}
        </option>
      );
    });
  };

  const renderSubOperators = (operators: Array<OperatorsSubListI> = []) => {              // отрисовывыается список саб-операторов
    return operators.map(({ ID, USER_LOGIN, LAST_NAME }) => {
      return (
        <option key={ID} value={ID}>
          {LAST_NAME}
        </option>
      );
    });
  };

  const { role } = useAppSelector((state) => state.user)                       // передаем переменную role и присваиваем ее значение typeUser для определение типа пользователя (теперь передаем typeList)
  const renderOperatorList = useMemo(() => renderOperators(listUsers), [])
  const renderOperatorSubList = useMemo(() => renderSubOperators(listSubUsers), [])

  const operator = () => {
    return listUsers.find((el) => operator_id === el.ID)?.LAST_NAME
  };
  const subOperator = () => {
    return listSubUsers.find((el) => operator_sub_id === el.ID)?.LAST_NAME
  };

  const onChangeStatus = (e: ChangeEvent<HTMLSelectElement>) => {
    changeStatus({ id, question_status: e.target.value, operator_id })
  }
  

  // const onChangeOperator = (e: ChangeEvent<HTMLSelectElement>, isSubOperator = false) => {                // менять статус "На рассмотрении" при выборе оператора
  //   const typeListValue = operator_id !== '88' && operator_id !== '94' ? 'listSubUsers' : 'listUsers'

  //   changeOperator({ 
  //     id, 
  //     operator_id: isSubOperator ? e.target.value : operator_sub_id || e.target.value, 
  //     typeList: typeListValue
  //     // typeUser: role
  //   })
  // }



  const onChangeOperator = (e: ChangeEvent<HTMLSelectElement>, isSubOperator = false) => {       
    const newOperatorId = e.target.value       
    const typeListValue = newOperatorId !== '88' && newOperatorId !== '94' && newOperatorId !== '95' && newOperatorId !== '302' && newOperatorId !== '303' && newOperatorId !== '304' && newOperatorId !== '305' && newOperatorId !== '306' && newOperatorId !== '307' && newOperatorId !== '308' && newOperatorId !== '310' ? 'listSubUsers' : 'listUsers'

    if (isSubOperator) {
        changeOperator({ 
            id, 
            operator_id: newOperatorId, 
            typeList: typeListValue
        })
    } else {
        changeOperator({ 
            id, 
            operator_id: newOperatorId, 
            typeList: typeListValue
        })
    }
  }


  const operatorBlock = () => {                               // выбор из списка операторов (исполнителей заявки) для 2 и 3 роли
    if (question_status === '1') {
      if (userRole !== '4') {                                 // для role === '3' показываем "Исполнитель: ИМЯ_ИСПОЛНИТЕЛЯ"
        if (!operator_sub_id) {
          return userRole !== '3' ? (
            <NativeSelect
              onClick={(e) => e.stopPropagation()}
              onChange={onChangeOperator}
              defaultValue={operator_id}
            >
              {renderOperatorList}
            </NativeSelect>
          ) : operator_id === '95' ? (
            <NativeSelect
              onClick={(e) => e.stopPropagation()}
              onChange={onChangeOperator}
              defaultValue={operator_id}
            >
              {renderOperatorSubList}
            </NativeSelect>
          ) : (
            <div>{operator()}</div>
          )          
        } else { 
          return userRole !== '3' ? (
            <NativeSelect
              onClick={(e) => e.stopPropagation()}
              onChange={onChangeOperator}
              defaultValue={operator_id}
            >
              {renderOperatorList}
            </NativeSelect>
          ) : operator_id === '95' ? (
            <NativeSelect
              onClick={(e) => e.stopPropagation()}
              onChange={onChangeOperator}
              defaultValue={operator_id}
            >
              {renderOperatorSubList}
            </NativeSelect>
          ) : (
            <div>{operator()}</div>
          )
        }
      }
    } else if (question_status === '2' || question_status === '3' || question_status === '5') {
      if (!operator_sub_id) {
        return userRole !== '3' ? (
          <NativeSelect
            onClick={(e) => e.stopPropagation()}
            onChange={onChangeOperator}
            defaultValue={operator_id}
          >
            {renderOperatorList}
          </NativeSelect>
        ) : operator_id === '95' ? (
          <NativeSelect
            onClick={(e) => e.stopPropagation()}
            onChange={onChangeOperator}
            defaultValue={operator_id}
          >
            {renderOperatorSubList}
          </NativeSelect>
        ) : (
          <div>{operator()}</div>
        )
      } else if (userRole === '3' && operator_id === '95') {
        return (
          <>
            <NativeSelect
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => onChangeOperator(e, true)}
              defaultValue={operator_sub_id}
            >
              {renderOperatorSubList}
            </NativeSelect>
        </>
        )
      } else {
        return userRole === '2' && <div>{operator()}</div>
      }
    } else if (question_status === '4') {
      if (!operator_sub_id) {
        return <div>{operator()}</div>
      } else {
        return userRole !== '3' ? (
          <div>{operator()}</div>
        ) : (
          <div>{subOperator()}</div>
        )
      }
    }
  }






  // const operatorBlock = () => {                               // выбор из списка операторов (исполнителей заявки) для 2 и 3 роли
  //   if (question_status === '1') {                            // для role === '3' показываем "Исполнитель: ПУСТО"
  //     if (userRole !== '4') {
  //       if (!operator_sub_id) {
  //         return userRole !== '3' ? (
  //           <NativeSelect
  //             onClick={(e) => e.stopPropagation()}
  //             onChange={onChangeOperator}
  //             defaultValue={operator_id}
  //           >
  //             {renderOperatorList}
  //           </NativeSelect>
  //         ) : operator_id === '95' && (
  //           <NativeSelect
  //             onClick={(e) => e.stopPropagation()}
  //             onChange={onChangeOperator}
  //             defaultValue={operator_id}
  //           >
  //             {renderOperatorSubList}
  //           </NativeSelect>
  //         )          
  //       } else { 
  //         return userRole !== '3' ? (
  //           <NativeSelect
  //             onClick={(e) => e.stopPropagation()}
  //             onChange={onChangeOperator}
  //             defaultValue={operator_id}
  //           >
  //             {renderOperatorList}
  //           </NativeSelect>
  //         ) : operator_id === '95' && (
  //           <NativeSelect
  //             onClick={(e) => e.stopPropagation()}
  //             onChange={onChangeOperator}
  //             defaultValue={operator_id}
  //           >
  //             {renderOperatorSubList}
  //           </NativeSelect>
  //         )
  //       }
  //     }
  //   } else if (question_status === '2' || question_status === '3' || question_status === '5') {
  //     if (!operator_sub_id) {
  //       return userRole !== '3' ? (
  //         <NativeSelect
  //           onClick={(e) => e.stopPropagation()}
  //           onChange={onChangeOperator}
  //           defaultValue={operator_id}
  //         >
  //           {renderOperatorList}
  //         </NativeSelect>
  //       ) : operator_id === '95' && (
  //         <NativeSelect
  //           onClick={(e) => e.stopPropagation()}
  //           onChange={onChangeOperator}
  //           defaultValue={operator_id}
  //         >
  //           {renderOperatorSubList}
  //         </NativeSelect>
  //       )
  //     } else if (userRole === '3' && operator_id === '95') {
  //       return (
  //         <>
  //           <NativeSelect
  //             onClick={(e) => e.stopPropagation()}
  //             onChange={(e) => onChangeOperator(e, true)}
  //             defaultValue={operator_sub_id}
  //           >
  //             {renderOperatorSubList}
  //           </NativeSelect>
  //       </>
  //       )
  //     } else {
  //       return userRole === '2' && <div>{operator()}</div>
  //     }
  //   } else if (question_status === '4') {
  //     if (!operator_sub_id) {
  //       return <div>{operator()}</div>
  //     } else {
  //       return userRole !== '3' ? (
  //         <div>{operator()}</div>
  //       ) : (
  //         <div>{subOperator()}</div>
  //       )
  //     }
  //   }
  // }


  const operatorBlockAdmin = () => {                                            // выбор из списка АДМИНОВ для 3 роли для перенаправки заявки в другое подразделение
    return (
      <NativeSelect
        onClick={(e) => e.stopPropagation()}
        onChange={onChangeOperator}
        defaultValue={operator_id}
      >
        {renderOperatorList}
      </NativeSelect>
    )
  }

  const operators = operatorBlock()
  const operatorsAdmin = operatorBlockAdmin()


  // const filesLinks = files?.map((el, idx) => (                                               // файлы, прикрепленные к обращению (без превью, название: файл 1, файл 2 и т.д.)
  //   <a href={el} target="_blank" rel="noreferrer" key={idx} className="email-link">
  //     файл {idx + 1}
  //   </a>
  // ));


  const filesLinks = files?.map((el, idx) => {
    const isImage = /\.(jpg|jpeg|png|gif)$/i.test(el);       // Проверяем, является ли файл изображением (по расширению)
    const isPdf = /\.pdf$/i.test(el);                        // Если файл формата pdf
    return (
      <div key={idx} className="file-preview">
        {isImage && (
          <a href={el} target="_blank" rel="noreferrer" title="Открыть в новом окне">
            <img src={el} />
          </a>
        )}
        {isPdf && (
          <a href={el} target="_blank" rel="noreferrer" title="Открыть в новом окне" style={{display: 'flex', flexDirection: 'column', gap: 10 }}>
            <svg fill="none" viewBox="0 0 142 175" width="50" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M140.687 93.1644C140.867 109.431 141.111 125.696 141.195 141.964C141.226 147.904 140.769 153.843 140.726 159.789C140.664 168.177 134.102 173.205 126.549 173.359C111.171 173.673 95.7887 174.043 80.4081 173.964C62.1048 173.871 43.8014 173.402 25.5027 172.933C21.2425 172.722 16.9978 172.267 12.7895 171.571C7.65492 170.849 2.60183 164.962 2.41608 159.374C1.94746 145.251 1.41382 131.124 1.25892 116.996C0.916312 85.9138 0.849366 54.8283 0.517257 23.7455C0.466719 18.9706 0.582881 14.345 2.55846 9.92649C4.03522 6.62121 6.14933 3.94077 9.81696 2.95101C11.1159 2.61352 12.4484 2.42131 13.7898 2.37799C19.5104 2.15156 25.2448 2.16377 30.9549 1.78703C52.4014 0.381158 73.846 1.45915 95.2925 1.63833C97.3468 1.59847 99.388 1.97594 101.292 2.74783C103.196 3.51971 104.924 4.66982 106.371 6.12886C113.287 12.689 120.702 18.7232 127.859 25.0313C130.804 27.6277 133.594 30.3994 136.493 33.0484C137.301 33.7478 137.954 34.6076 138.412 35.573C138.87 36.5386 139.122 37.5892 139.152 38.6574C139.386 44.5959 139.756 50.5316 139.854 56.4714C140.055 68.7013 140.113 80.9335 140.231 93.165L140.687 93.1644ZM93.3799 10.0906C91.9662 9.94487 90.9712 9.76864 89.9729 9.75026C75.1567 9.47637 60.3403 9.21712 45.5236 8.97342C39.1296 8.87235 32.7342 8.83717 26.3395 8.79713C23.09 8.77678 19.8326 8.67361 16.5936 8.85804C12.1305 9.11204 10.6105 10.4209 10.0158 14.9523C9.56047 18.7257 9.34821 22.5246 9.38043 26.3254C9.37321 30.6933 9.80049 35.0604 9.83199 39.4297C9.92847 52.7783 9.94692 66.1273 9.95676 79.4764C9.97468 104.266 9.98078 129.056 9.97514 153.845C9.93917 154.856 10.0032 155.866 10.1661 156.864C11.1769 161.866 13.8416 164.576 19.0188 164.792C41.0186 165.711 63.0196 165.692 85.0274 165.289C95.8038 165.092 106.583 165.033 117.361 164.917C120.052 164.888 122.75 164.996 125.434 164.838C129.65 164.591 132.02 162.131 131.971 157.921C131.912 152.655 131.562 147.394 131.47 142.128C131.375 136.634 131.564 131.132 131.404 125.641C130.997 111.516 130.304 97.3984 130.036 83.272C129.815 71.498 130.036 59.7163 130.05 47.9384C130.05 47.0851 129.926 46.2362 129.884 45.7066C122.543 45.7066 115.485 45.7724 108.431 45.6681C106.08 45.6287 103.739 45.3414 101.448 44.8105C98.0301 44.0183 96.0952 41.8164 95.876 38.158C95.6338 34.1307 95.2282 30.1134 94.8659 26.094C94.3953 20.8545 93.8958 15.6261 93.3799 10.0906ZM124.647 36.3806C124.768 36.1706 124.889 35.9609 125.01 35.7512L102.689 15.4926L102.174 15.7502C103.277 22.97 104.38 30.1894 105.505 37.5568L124.647 36.3806Z" fill="black"/><path d="M62.7033 132.498C63.0315 123.33 63.3472 114.161 63.7095 104.994C63.8322 101.879 64.4596 101.526 67.6015 100.75C76.6321 98.5181 83.3248 101.989 88.6857 108.989C89.0946 109.522 89.4661 110.086 89.8862 110.61C100.754 124.163 91.0676 140.352 78.3346 143.579C75.624 144.275 72.8765 144.819 70.1048 145.209C68.4883 145.465 66.8369 145.068 65.5123 144.107C64.1879 143.146 63.2989 141.698 63.0407 140.082C62.5694 137.588 62.297 135.06 61.936 132.547L62.7033 132.498ZM69.4531 136.865C72.5687 137.019 75.6791 136.471 78.5552 135.263C86.909 131.616 89.7936 123.146 85.2688 115.296C84.1682 113.346 82.8798 111.508 81.4227 109.808C80.2177 108.381 78.7291 107.219 77.0522 106.396C75.3752 105.574 73.5453 105.108 71.6787 105.029C72.2858 115.817 70.4848 126.197 69.4557 136.865H69.4531Z" fill="black"/><path d="M35.6898 130.113C35.4541 132.697 35.3045 135.131 34.9822 137.541C34.8379 138.872 34.4918 140.173 33.9558 141.399C33.683 142.091 33.1642 142.658 32.499 142.992C31.8337 143.325 31.069 143.401 30.3512 143.205C28.7189 142.807 27.9582 141.626 27.9838 139.971C28.0612 134.933 28.1708 129.895 28.2463 124.856C28.3224 119.707 28.4031 114.557 28.4221 109.406C28.4313 106.814 29.0936 104.61 31.2228 102.901C35.8388 99.1989 41.0075 98.5038 46.4315 100.357C48.7269 101.136 50.8462 102.36 52.6681 103.959C54.4899 105.559 55.9786 107.501 57.049 109.676C59.0456 113.578 58.6596 117.487 56.1393 121.117C52.0267 127.042 46.0265 129.344 39.135 129.912C38.0389 129.997 36.9394 130.04 35.6898 130.113ZM34.5143 107.821C34.7486 112.586 34.9902 117.507 35.2573 122.941C38.4077 122.362 41.1545 122.001 43.8199 121.323C46.2805 120.698 48.1169 119.026 49.6226 117.003C50.1492 116.346 50.4635 115.544 50.5235 114.704C50.5835 113.863 50.3865 113.025 49.9586 112.299C47.1133 106.66 40.5992 104.65 34.5143 107.82V107.821Z" fill="black"/><path d="M106.6 122.902C106.306 128.172 106.092 132.857 105.751 137.533C105.693 138.757 105.376 139.955 104.823 141.049C104.559 141.582 104.149 142.029 103.642 142.341C103.135 142.652 102.55 142.814 101.955 142.809C101.36 142.803 100.779 142.629 100.277 142.309C99.7758 141.988 99.3755 141.533 99.1208 140.995C98.5997 140.005 98.2892 138.918 98.2098 137.803C97.3979 126.811 97.9204 115.837 98.8911 104.882C99.1438 103.335 99.5848 101.825 100.204 100.385C100.766 98.7847 102.201 98.2307 103.679 98.1644C110.066 97.8769 116.457 97.5823 122.849 97.5402C125.844 97.5199 127.387 98.9967 127.333 101.037C127.28 103.078 125.65 104.331 122.715 104.384C118.114 104.464 113.51 104.446 108.907 104.467C107.923 104.472 106.938 104.467 105.983 104.467V114.9C108.292 114.9 110.267 114.896 112.243 114.9C113.359 114.834 114.478 114.855 115.59 114.961C116.492 115.067 117.328 115.486 117.952 116.146C118.576 116.806 118.948 117.665 119.003 118.571C118.995 119.421 118.713 120.244 118.201 120.922C117.689 121.599 116.972 122.094 116.157 122.333C114.857 122.668 113.522 122.852 112.179 122.881C110.402 122.969 108.617 122.902 106.6 122.902Z" fill="black"/></g><defs><clipPath id="clip0"><rect fill="white" height="173.93" transform="translate(0.154297 0.574219)" width="141.113"/></clipPath></defs></svg>
            файл {idx + 1}
          </a>
        )}
      </div>
    );
  });


  return (
    <Accordion
      onChange={() => {
        setExpand(!expand);
      }}
      className="single-appeal"
    >
      <AccordionSummary
        aria-controls="panel1a-content"
        id="panel1a-header"
        sx={{ height: 60, padding: 0 }}
      >
        <div className={`table request  ${appealClosed} ${appealColor}`}>

          {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="red" stroke="black" stroke-width="2" width="14" height="14">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg> */}

          {role === '3' && operator_id === '95' ? (
            <Checkbox
              checked={isChecked}
              onChange={(e) => {
                onCheckBoxChange(id, e.target.checked)
              }}
              onClick={(e) => e.stopPropagation()}
              disabled={question_status === '4'}
              disableRipple
            />
          ) : (
            <Checkbox
              sx={{ visibility: 'hidden' }}  
            />
          )}
        
          <div className="table__block">{id}</div>                                            
          <div className="table__block">{date_question}</div>
          <div className="table__block">{date_final_ask}</div>
          <div className="table__block">{ques_name || 'нет данных'}</div>
          <div className="table__block">{userRole !== '2' ? subOperator() : operator()}</div>
          <div className="table__block">
            <NativeSelect
              onClick={(e) => e.stopPropagation()}
              onChange={onChangeStatus}
              defaultValue={question_status}
              inputProps={{
                name: 'status',
                id: 'status',
              }}
            >
              <option value={'1'}>Новое</option>
              <option value={'2'}>На рассмотрении</option>
              <option value={'3'}>Отправлен запрос</option>
              <option value={'5'}>Продлен срок</option>
              <option value={'4'}>Выполнено</option>
            </NativeSelect>
          </div>
          <div className="table__block">{summaryContent}</div>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className={`table__info ${appealClosed}`}>
          <div className="table__info-personal">
            <div>
              <div className="table__info-wrapper">
                <div className="table__info-name table__info-block">
                  <div className="table__info-subtitle">Имя:</div>
                  <div className='flex flex-col'>
                    <div>{fio}</div>
                    <div>{login}</div>
                  </div>
                </div>
                <div className="table__info-phone table__info-block">
                  <div className="table__info-subtitle">Телефон:</div>
                  {phone || 'нет данных'}
                </div>
                <div className="table__info-email table__info-block">
                  <div className="table__info-subtitle">Email:</div>
                  {email ? (
                    <Tooltip title="Ответить по почте">
                      <span onClick={() => sendEmail(email, id)} className="email-link">
                        {email}
                      </span>
                    </Tooltip>
                  ) : (
                    'нет данных'
                  )}
                </div>
                {address ? (
                  <div className="table__info-address table__info-block">
                    <div className="table__info-subtitle">Адрес:</div>
                    {address || 'нет данных'}
                  </div>
                ) : null}
                <div className="table__info-block">
                  <div className="table__info-subtitle">№ обращения:</div>
                  {id}
                </div>
                <div className="table__info-block">
                  <div className="table__info-subtitle">Отправитель:</div>
                  {sender_name}
                </div>
              </div>
              {files?.length && (
                <div className="table__info-block">
                  <div className="table__info-subtitle">Файлы:</div>
                  <div className="table__info-files">{filesLinks}</div>
                </div>
              )}
            </div>

            <div className="table__info-question table__info-block">
              <div className="table__info-subtitle">Вопрос:</div>
              {question}
            </div>
          </div>

          <div className="table__info-btns">
             {userRole === '3' && question_status !== '4' ? (
              <div className="table__info-priority">
                <InputLabel htmlFor="status" sx={{ margin: 1 }}>       
                  Перенести заявку:
                </InputLabel>
                {operatorsAdmin}
              </div>) : null
            }

            {date_destination !== null ? (
              <div className="table__info-priority">
                <InputLabel htmlFor="status" sx={{ margin: 1 }}>
                  Дата назначения:
                  {date_destination}
                </InputLabel>
              </div>) : null
            }

            {userRole !== '4' ? (
              <div className="table__info-priority">
                <InputLabel htmlFor="status" sx={{ margin: 1 }}>
                  Исполнитель:
                </InputLabel>
                {operators}
              </div>) : null
            }
            
            <div className="table__info-priority">
              <InputLabel htmlFor="priority" sx={{ margin: 1 }}>
                Приоритет:
              </InputLabel>
              <NativeSelect
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => {
                  changePriority({ id, priority: e.target.value });
                }}
                defaultValue={priority}
                inputProps={{
                  name: 'priority',
                  id: 'priority',
                }}
              >
                <option value={'1'}>Обычный</option>
                <option value={'3'}>Средний</option>
                <option value={'2'}>Высокий</option>
              </NativeSelect>
            </div>
            <FormControlLabel
              control={<Checkbox checked={phone_status === '2'} onChange={answeredByPhone} />}
              label="Отвечено по телефону"
            />
            <ButtonGroup variant="outlined" aria-label="outlined button group">
              <Button
                variant="contained"
                onClick={() => {
                  handleOpen(handleOpenProps);
                }}
              >
                Ответ
              </Button>
              <Button
                variant="outlined"
                onClick={() => {
                  handleOpenModalSend(id);
                }}
              >
                Переслать
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

export default SingleAppeal;